import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Partner, TextSectionIdentifier } from '@fitscovery/partner/data-access';

@Component({
  selector: 'fitscovery-ui-groove-banner',
  templateUrl: './ui-groove-banner.component.html',
  styleUrls: ['./ui-groove-banner.component.scss']
})
export class UiGrooveBannerComponent implements OnInit {
  @Input() partner: Partner;

  constructor(private router: Router) {}

  ngOnInit(): void {
  }
  getHeader(): string {
    const header = this.partner.textSections!.find((section) => {
      return section.identifier === TextSectionIdentifier.Header;
    });
    return header && header.text ? header.text : this.partner.name!;
  }

  getSubHeader(): string {
    const header = this.partner.textSections!.find((section) => {
      return section.identifier === TextSectionIdentifier.Description;
    });
    return header! && header.text!;
  }

  goToSchedule(): void {
    this.router.navigate(['/events/list']);
  }

  contactMe(): void {
    const email =
      this.partner && this.partner.contactInfo
        ? `mailto:${this.partner.contactInfo.email}`
        : null;
    //TODO: [AA] Call url service to redirect to email url
  }
}
